// extracted by mini-css-extract-plugin
export default {"infoAction":"HeaderActions_infoAction__98Iiz"};